// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__dSjGP","additionalInfo":"AgreementModal_additionalInfo__2JyeC"};